// extracted by mini-css-extract-plugin
module.exports = {"type-icon-wrap":"style_type-icon-wrap__2NBv9","issue":"style_issue__Nd0Tk","service":"style_service__spvjk"};